import React from "react"
import ReactDOM from "react-dom"
import "frontend/styles/fonts.css"
import "frontend/styles/colors.css"

import UploadScreen from "./UploadScreen"

const domContainer = document.querySelector("#redesigned-upload")

ReactDOM.render(<UploadScreen />, domContainer)
